<template>
  <div class="page-box">
    <div class="lang-box">
      <el-radio-group v-model="type" size="medium" @change="onTypeChange">
        <el-radio-button v-if="documentDetail.type == '1' || documentDetail.type == '3'" label="1">中文
        </el-radio-button>
        <el-radio-button v-if="documentDetail.type == '2' || documentDetail.type == '3'" label="2">英文
        </el-radio-button>
      </el-radio-group>
    </div>
    <div class="document-box" v-if="type=='1'">
      <el-scrollbar class="el-scrollbar" ref="view-box">
        <div class="view-box">
          <div class="html" v-html="documentDetail.content"></div>
        </div>
      </el-scrollbar>
    </div>
    <div class="document-box" v-if="type=='2'">
      <el-scrollbar class="el-scrollbar" ref="view-box">
        <div class="view-box">
          <div class="html" v-html="documentDetail.englishContent"></div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import {singleDocumentsSever} from "@/common/api-config";

export default {
  inject: ['reload'],
  created() {
  },
  mounted() {
    if (this.$route.params.id) {
      this.queryDocumentDetail();
      this.scrollContainer = document.getElementsByClassName('view-box')[0];
      this.scrollContainer.addEventListener('scroll', utils.throttle(this.handleScroll, 100), { passive: true });
    }
  },
  watch: {
    '$route.params.id'(to, from) {
      this.reload()
    }
  },
  data() {
    return {
      scrollContainer: HTMLElement,
      type: '1',
      isTop: true,
      documentDetail: '',
    };
  },
  methods: {
    onTypeChange() {
      this.$router.replace({
        path: "/documents/" + this.$route.params.id,
        query: {
          type: this.type,
        }
      });
      this.reload()
    },
    //替换富文本内容img src 改为懒加载
    replaceImgSrc(questionContent) {
      questionContent = questionContent.replace(
          new RegExp(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi),
          function (match, capture) {
            match = `<img  data-src="${capture}">`;
            return match;
          }
      );
      // 替换 px 为 vw
      questionContent = questionContent.replace(/(\d+)px/g, (match, p1) => {
        const vwValue = (parseInt(p1) / 1920) * 100;
        return `${vwValue}vw`;
      });
      return questionContent;
    },
    //滚动检查
    handleScroll() {
      //获取滚动时的高度
      let scrollTop = this.scrollContainer.scrollTop;
      //图片懒加载(默认第一个张图加载)
      $('.html img').not('[data-isLoaded]').each(function () {
        var $img = $(this)
        if ($img.offset().top <= scrollTop) {
          $img.attr('src', $img.attr('data-src')) //把data-src的值 赋值给src
          $img.attr('data-isLoaded', 1)//已加载的图片做标记
        }
      })
    },
    //同步目录滚动
    awaitScroll(top) {
      $('.nav-fixed-box').animate({
        scrollTop: top
      }, 300);
    },
    //获取新闻详情
    queryDocumentDetail() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      $('.nav-fixed').html('');
      singleDocumentsSever.queryDetail({
        id: this.$route.params.id,//	string
      })
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.documentDetail = res.data;
              if (this.$route.query.type) {
                this.type = this.$route.query.type ? this.$route.query.type : '1';
              } else {
                if (this.documentDetail.type == '1') {
                  this.type = '1'
                }
                if (this.documentDetail.type == '2') {
                  this.type = '2'
                }
              }
              if (res.data.content) {
                this.documentDetail.content = this.replaceImgSrc(res.data.content)
              }
              if (res.data.englishContent) {
                this.documentDetail.englishContent = this.replaceImgSrc(res.data.englishContent)
              }
              this.$nextTick(() => {
                prismjs.highlightAll();
                this.toc();
                //默认第一个张图加载
                $('.html img').eq(0).attr('src', $('.html img').eq(0).attr('data-src')) //把data-src的值 赋值给src
              });
            } else {
              this.$message.error(res.message);
              this.$router.replace({
                path: '/documents',
              })
            }
          });
    },
    //目录
    toc() {
      // Find the TOC container element.
      // If there isn't one, create one at the start of the document.
      var that = this;
      var toc = document.getElementById("TOC");
      if (!toc) {
        toc = document.createElement("div");
        toc.id = "TOC";
        $('.nav-fixed').append(toc);
        $(".nav-fixed").on("click", ".TOCEntry a", function () {
          $('.TOCEntry').removeClass('active');
          $(this).parent('.TOCEntry').addClass('active');
        });
      }
      // Find all section heading elements
      var headings;
      if (document.querySelectorAll) // Can we do it the easy way?
        headings = $('.html h1,h2,h3,h4,h5,h6');
      else   // Otherwise, find the headings the hard way
        headings = findHeadings(document.body, []);

      // Recursively traverse the document body looking for headings
      function findHeadings(root, sects) {
        for (var c = root.firstChild; c != null; c = c.nextSibling) {
          if (c.nodeType !== 1) continue;
          if (c.tagName.length == 2 && c.tagName.charAt(0) == "H")
            sects.push(c);
          else
            findHeadings(c, sects);
        }
        return sects;
      }

      // Initialize an array that keeps track of section numbers.
      var sectionNumbers = [0, 0, 0, 0, 0, 0];
      // Now loop through the section header elements we found.
      this.isTop = headings.length;
      for (var h = 0; h < headings.length; h++) {
        var heading = headings[h];
        // Skip the section heading if it is inside the TOC container.
        if (heading.parentNode == toc) continue;
        // Figure out what level heading it is.
        var level = parseInt(heading.tagName.charAt(1));
        if (isNaN(level) || level < 1 || level > 6) continue;
        // Increment the section number for this heading level
        // and reset all lower heading level numbers to zero.
        sectionNumbers[level - 1]++;
        for (var i = level; i < 6; i++) sectionNumbers[i] = 0;
        // Now combine section numbers for all heading levels
        // to produce a section number like 2.3.1.
        var sectionNumber = sectionNumbers.slice(0, level).join(".")
        // Add the section number to the section header title.
        // We place the number in a <span> to make it styleable.
        // var span = document.createElement("span");
        // span.className = "TOCSectNum";
        // span.innerHTML = sectionNumber;
        // heading.insertBefore(span, heading.firstChild);
        // Wrap the heading in a named anchor so we can link to it.
        var anchor = document.createElement("a");
        anchor.name = "TOC" + sectionNumber;
        heading.parentNode.insertBefore(anchor, heading);
        anchor.appendChild(heading);
        // Now create a link to this section.
        var link = document.createElement("a");
        link.href = "#TOC" + sectionNumber; // Link destination
        link.innerHTML = heading.innerHTML; // Link text is same as heading
        // Place the link in a div that is styleable based on the level.
        var entry = document.createElement("div");
        entry.className = "TOCEntry TOCLevel" + level;
        entry.appendChild(link);
        // And add the div to the TOC container.
        toc.appendChild(entry);
      }
    }
  },
  destroyed() {
    this.scrollContainer.removeEventListener('scroll', this.handleScroll)
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.lang-box {
  margin-bottom: 10px;
  text-align: right;
}

/*主体*/
.document-box {
  position: relative;
  height: 100%;
  display: flex;

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-scrollbar {
    position: relative;
    flex: 1;
    height: 100%;
    box-sizing: border-box;
    border: 1px solid #EEEEEE;
    border-radius: 5px;

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .view-box {
      position: relative;
      height: 100vh;
      padding: 20px;
      background: #fff;
      overflow-y: auto; /* 或 scroll */
      -webkit-overflow-scrolling: touch; /* iOS 优化 */

      .html {
        padding: 0;
        width: 100% !important;
        overflow-x: auto;
        font-size: 14px;

        img {
          display: block;
          max-width: 100%;
          width: 100%;
        }

        a {
          text-decoration: none;

          &:hover {
            text-decoration: none;
          }
        }

        html, address, blockquote, body, dd, div, dl, dt, fieldset, form, frame, frameset, h1, h2, h3, h4, h5, h6, noframes, ol, p, ul, center, dir, hr, menu, pre {
          display: block;
          unicode-bidi: embed
        }

        li {
          display: list-item;
          list-style-type: disc;
        }

        head {
          display: none
        }

        table {
          display: table
        }

        tr {
          display: table-row
        }

        thead {
          display: table-header-group
        }

        tbody {
          display: table-row-group
        }

        tfoot {
          display: table-footer-group
        }

        col {
          display: table-column
        }

        colgroup {
          display: table-column-group
        }

        td, th {
          display: table-cell
        }

        caption {
          display: table-caption
        }

        th {
          font-weight: bolder;
          text-align: center
        }

        caption {
          text-align: center
        }

        body {
          margin: 8px
        }

        h1 {
          font-size: 2em;
          margin: .67em 0
        }

        h2 {
          font-size: 1.5em;
          margin: .75em 0
        }

        h3 {
          font-size: 1.17em;
          margin: .83em 0
        }

        h4, p, blockquote, ul, fieldset, form, ol, dl, dir, menu {
          margin: 1.12em 0
        }

        h5 {
          font-size: .83em;
          margin: 1.5em 0
        }

        h6 {
          font-size: .75em;
          margin: 1.67em 0
        }

        h1, h2, h3, h4, h5, h6, b, strong {
          font-weight: bolder
        }

        blockquote {
          margin-left: 40px;
          margin-right: 40px
        }

        i, cite, em, var, address {
          font-style: italic
        }

        pre, tt, code, kbd, samp {
          font-family: monospace
        }

        pre {
          white-space: pre
        }

        button, textarea, input, select {
          display: inline-block
        }

        big {
          font-size: 1.17em
        }

        small, sub, sup {
          font-size: .83em
        }

        sub {
          vertical-align: sub
        }

        sup {
          vertical-align: super
        }

        table {
          border-spacing: 2px;
        }

        thead, tbody, tfoot {
          vertical-align: middle
        }

        td, th, tr {
          vertical-align: inherit
        }

        s, strike, del {
          text-decoration: line-through
        }

        hr {
          border: 1px inset
        }

        ol, ul, dir, menu, dd {
          margin-left: 40px
        }

        ol {
          list-style-type: decimal
        }

        ol ul, ul ol, ul ul, ol ol {
          margin-top: 0;
          margin-bottom: 0
        }

        u, ins {
          text-decoration: underline
        }

        br:before {
          content: "\A";
          white-space: pre-line
        }

        center {
          text-align: center
        }

        :link, :visited {
          text-decoration: underline
        }

        :focus {
          outline: thin dotted invert
        }

        /* Begin bidirectionality settings (do not change) */
        BDO[DIR="ltr"] {
          direction: ltr;
          unicode-bidi: bidi-override
        }

        BDO[DIR="rtl"] {
          direction: rtl;
          unicode-bidi: bidi-override
        }

        *[DIR="ltr"] {
          direction: ltr;
          unicode-bidi: embed
        }

        *[DIR="rtl"] {
          direction: rtl;
          unicode-bidi: embed
        }

        @media print {
          h1 {
            page-break-before: always
          }

          h1, h2, h3,
          h4, h5, h6 {
            page-break-after: avoid
          }

          ul, ol, dl {
            page-break-before: avoid
          }
        }

        pre[class*="language-"] {
          border: 0;
          box-shadow: none;
        }
      }
    }
  }

  .nav-fixed-box {
    margin-left: 10px;
    width: 300px;
    height: 100%;
    padding: 20px 0 40px 0;
    border: 1px solid #EEEEEE;
    border-radius: 5px;
    overflow-y: scroll;
    background: #fff;

    .nav-fixed-title {
      margin-bottom: 10px;
      font-size: 16px;
      font-weight: bold;
      text-indent: 20px;
      color: #000;
    }

    .nav-fixed {
      position: relative;
    }

    #TOC {
      .TOCEntry {
        // padding: 1px 0;
        line-height: 35px;
        vertical-align: middle;
        white-space: nowrap;
        word-break: keep-all;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 16px;

        a {
          color: #5c5c5c;
          text-decoration: none;

          span {
            color: #5c5c5c !important;
          }

          &:hover {
            text-decoration: none;
          }
        }

        strong {
          font-weight: normal;
        }
      }

      .active {
        position: relative;
        background: #F6F6F6;

        a, strong {
          color: #4CA2FF;

          span {
            color: #4CA2FF;
          }
        }

        &::after {
          position: absolute;
          left: 0;
          width: 5px;
          height: 100%;
          content: '';
          background: #4CA2FF;
        }
      }

      .TOCLevel1 {
        text-indent: 20px;
      }

      .TOCLevel2 {
        text-indent: 40px;
      }

      .TOCLevel3 {
        text-indent: 60px;
      }

      .TOCLevel4 {
        text-indent: 80px;
      }

      .TOCLevel5 {
        text-indent: 100px;
      }

      .TOCLevel6 {
        text-indent: 120px;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .nav-fixed-box {
    display: none;
  }
}
</style>
